import css from "styled-jsx/css";
import getColor, { COLOR_DICTIONARY } from "@gc-npm/utils.enums.colors";

export default css`
  .color-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.75rem;
    list-style: none;
    /* El anillo del circulo seleccionado (box-shadow 0.25rem) pinta 4px por
       fuera del ciculo. El padding desplaza los circulos 4px hacia dentro
       para que el borde EXTERIOR del anillo quede exactamente en la linea del
       texto de encima (sin el padding, la bola seleccionada se ve desplazada
       a la izquierda del texto). */
    padding: 0.25rem;
    margin: 0;
    &--option {
      position: relative;
      display: block;
      cursor: pointer;
    }
    &--input {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      margin: 0;
      opacity: 0;
      cursor: pointer;
      &:focus-visible + .color-row--circle {
        outline: 2px solid ${getColor(COLOR_DICTIONARY.BLUE_HIGH)};
        outline-offset: 6px;
      }
    }
    &--circle {
      display: block;
      width: 1.5rem;
      height: 1.5rem;
      border-radius: 50%;
      border: 1px solid #dddddd;
      box-sizing: border-box;
      &--selected {
        border-color: transparent;
        box-shadow:
          0 0 0 0.125rem #ffffff,
          0 0 0 0.25rem ${getColor(COLOR_DICTIONARY.MOVISTAR_BLUE)};
      }
    }
  }
`;
